import React from 'react';
import classnames from 'classnames';
import { ItemType } from 'components/Common/FieldCustom/SelectFieldCustom/SelectFieldCustom';
import { ExtraStyleType } from '../ProductSelectItem/ProductSelectItem';
import styles from './ProductSizePicker.module.scss';

/**
 * Product page of website. Contains details product data.
 */
function ProductSizePicker({
  items,
  size,
  setSize,
}: {
  items: ItemType[];
  size?: string;
  setSize: (size: string) => void;
}): JSX.Element {
  const extraStyle: ExtraStyleType = {
    label: styles.itemLabel,
  };

  return (
    <ul>
      {items.map(item => {
        const customizedContent = React.cloneElement(
          item.content as JSX.Element,
          {
            extraStyle: extraStyle,
          }
        );
        const { disabled } = item;

        return (
          <li
            className={classnames(styles.item, {
              [styles.selected]: size === item.value,
              [styles.disabled]: disabled,
            })}
            key={item.value}
            onClick={() => !disabled && setSize(item.value)}
          >
            {customizedContent}
          </li>
        );
      })}
    </ul>
  );
}

export default ProductSizePicker;
